import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";


export const getExhibitionFn = () => {
    const response = protectedApi.get(`${ENDPOINTS.exhibtion}`);
    return response;
}

export const getExhibitionByIdFn = (id) => {
    const response = protectedApi.get(`${ENDPOINTS.exhibtion}`);
    return response;
}

export const postExhibitionFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.exhibtion}`, reqBody);
    return response;
}

export const patchExhibitionFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.exhibtion}`, reqBody);
    return response;
}

export const deleteExhibitionFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.exhibtion}`, { data: reqBody });
    return response;
}
